import { type TurnId } from "@cmmd-forge/contracts";
import { type RefObject, useEffect } from "react";

import { useRightPanelStore } from "../../rightPanelStore";

/**
 * Open the plan panel once per turn that proposes one.
 *
 * The per-turn ref is what stops this re-firing; it is claimed before the
 * surface opens, so a re-render mid-open cannot open it twice.
 */
export function useAutoOpenPlanPanel(input: {
  readonly activePlan: { readonly turnId?: TurnId } | null;
  readonly latestTurnId: TurnId | null;
  readonly planOpen: boolean;
  readonly planAutoOpenedForTurnRef: RefObject<string | null>;
  readonly threadKey: string | null;
}): void {
  const { activePlan, latestTurnId, planAutoOpenedForTurnRef, planOpen, threadKey } = input;

  useEffect(() => {
    if (!threadKey || !activePlan || planOpen) return;
    if (latestTurnId && activePlan.turnId !== latestTurnId) return;
    const turnKey = activePlan.turnId ?? "__current__";
    if (planAutoOpenedForTurnRef.current === turnKey) return;
    planAutoOpenedForTurnRef.current = turnKey;
    useRightPanelStore.getState().open(threadKey, "plan");
  }, [activePlan, latestTurnId, planAutoOpenedForTurnRef, planOpen, threadKey]);
}
